module.exports = __webpack_public_path__ + "img/Oluwaseun Bukky Afolabi_Data Lead.992f85bf.jpg";